import { useSelector } from "react-redux";
import { UserRole } from "../../shared/constants";
import { RootState } from "../../store/types";

interface IAuthorizeGuardProps {
  children: any;
  allowedRole: UserRole
}

const AuthorizeGuard = (props: IAuthorizeGuardProps) => {
  const { children, allowedRole } = props;
  const { loggedInUser } = useSelector((state: RootState) => state.global);

  // if (loggedInUser?.role === allowedRole)
    return children;
  // else {
  //   return (
  //     <div>
  //       <h2>Authorization Failed</h2>
  //       <p>You do not have access to this page.</p>
  //     </div>
  //   );
  // }
};

export default AuthorizeGuard;
